import { maxProductQuantity } from '@/features/pos/components/ProductConfigurationModal/form/constants'
import IconButton from '@/features/ui/buttons/components/IconButton'
import MinusIcon from '@/features/ui/icons/components/MinusIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

export interface QuantitySelectorProps {
    quantity: number
    disabled: boolean
    decrease: () => void
    increase: () => void
}

const QuantitySelector: FC<QuantitySelectorProps> = ({
    quantity,
    disabled,
    decrease,
    increase,
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <View style={styles.column}>
                <IconButton
                    type="outline"
                    color="secondary"
                    size={44}
                    Icon={MinusIcon}
                    disabled={disabled || quantity <= 1}
                    onPress={decrease}
                    accessibilityRole="button"
                    accessibilityLabel={t('pos.productConfiguration.decreaseQuantity')}
                    testID="product-quantity-decrease"
                    style={styles.button}
                />
            </View>
            <View style={styles.column}>
                <IconButton
                    type="filled"
                    color="secondary"
                    size={44}
                    Icon={({ fill }) => (
                        <Typography.Heading variant="h3" style={{ color: String(fill) }}>
                            {quantity}
                        </Typography.Heading>
                    )}
                    disabled={disabled || quantity >= maxProductQuantity}
                    onPress={increase}
                    accessibilityRole="button"
                    accessibilityLabel={t('pos.productConfiguration.increaseQuantity', {
                        quantity,
                    })}
                    testID="product-quantity-increase"
                    style={styles.button}
                />
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        gap: 16,
    },
    column: {
        flex: 1,
        minWidth: 0,
    },
    button: {
        width: '100%',
    },
})

export default QuantitySelector
